import breakpoints from '@carvana/merch-tailwind/screens';
import { useContext, useEffect, useState } from 'react';
import DeviceContext from '~/contexts/DeviceContext';
import type { ScreenSize } from '~/contracts';
import isSSR from '~/utilities/IsServerSideRendering';

const mobileMediaQuery = `(max-width: ${breakpoints.m - 1}px)`;
const tabletMediaQuery = `(min-width: ${breakpoints.m}px) and (max-width: ${
  breakpoints.l - 1
}px)`;
const desktopMediaQuery = `(min-width: ${breakpoints.l}px)`;

const getHeight = (): number =>
  Math.min(document.documentElement.clientHeight, window.innerHeight);

const getWidth = (): number =>
  Math.min(document.documentElement.clientWidth, window.innerWidth);

export default function useResizeListener(): void {
  const { setScreenSize } = useContext(DeviceContext);

  const [height, setHeight] = useState(isSSR ? 1001 : getHeight());
  const [width, setWidth] = useState(isSSR ? 1293 : getWidth());

  useEffect(() => {
    let resizeTimeout;

    function onResize() {
      if (resizeTimeout) {
        window.cancelAnimationFrame(resizeTimeout);
      }

      resizeTimeout = window.requestAnimationFrame(() => {
        setHeight(
          Math.min(document.documentElement.clientHeight, window.innerHeight)
        );
        setWidth(
          Math.min(document.documentElement.clientWidth, window.innerWidth)
        );
      });
    }

    onResize();

    window.addEventListener('resize', onResize, false);

    return () => {
      // window.cancelAnimationFrame(resizeTimeout);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    const { matchMedia } = window;

    const screenSize: ScreenSize = {
      height,
      isDesktop: matchMedia(desktopMediaQuery).matches,
      isMobile: matchMedia(mobileMediaQuery).matches,
      isTablet: matchMedia(tabletMediaQuery).matches,
      width
    };

    setScreenSize(screenSize);
  }, [height, setScreenSize, width]);
}
